/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-06-06",
    versionChannel: "nightly",
    buildDate: "2024-06-06T00:05:39.349Z",
    commitHash: "091aa2361f989c067a922b0e9603f78050b325ba",
};
